import { useAppSelector } from 'rtk/query/hooks';
import { EUserType } from 'types/accessControll.types';
import type { TAdminUser, TRecruiterAppUser } from 'types/user.types';

export function useUserRole() {
  const user = useAppSelector((state) => state.config.user);
  if (!user) {
    return null;
  }
  return user.userType;
}

export function useUser() {
  const user = useAppSelector((state) => state.config.user);
  if (!user) {
    throw new Error('No user');
  }
  if (user.userType === EUserType.RECRUITER) {
    return user as TRecruiterAppUser;
  }
  if (user.userType === EUserType.HUBERT) {
    return user as TAdminUser;
  }

  return user;
}
